export const fileExtensions = {
  documents: [
    'doc',
    'docx',
    'docm',
    'accdb',
    'mdb',
    'accdb',
    'mdb',
    'accdb',
    'mdb',
    'mdb',
    'mdb',
    'rtf',
    'rtf',
    'fodt',
    'fodp',
    'wdp',
    'txt',
    'html',
    'pdf',
    'pdf',
    'pdf',
    'pdf',
    'key',
    'pages',
    'numbers',
    'asice',
    'ggb',
  ],
  presentation: ['odp', 'odt', 'pps', 'ppt', 'pptx', 'pptm', 'ppsx'],
  sheets: ['csv', 'ods', 'fods', 'xml', 'xls', 'xlsx', 'xlsm'],
  displayImage: ['ico', 'cur', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'gif', 'bmp', 'apng'],
  image: [
    'jpg',
    'jpeg',
    'jpe',
    'jif',
    'jfif',
    'jfi',
    'png',
    'bmp',
    'bmp',
    'bmp',
    'gif',
    'webp',
    'tiff',
    'tiff',
    'jp2',
    'jpf',
    'jpx',
    'jpm',
    'jp2',
    'xcf',
    'heif',
    'heic',
    'heif',
    'heic',
    'heif',
    'heic',
    'heif',
    'heic',
    'ai',
    'eps',
    'epse',
    'epsi',
    'psd',
    'tga',
    'tga',
    'eps',
    'epse',
    'epsi',
    'eps',
    'epse',
    'epsi',
    'eps',
    'epse',
    'epsi',
    'eps',
    'epse',
    'epsi',
    'svg',
    'svgz',
    'k25',
    'raw',
    'arw',
    'crw',
    'nrw',
  ],
  video: [
    'webm',
    'mpg',
    'mpeg',
    'mp2',
    'mpe',
    'ogg',
    'ogg',
    'mp4',
    'm4a',
    'm4p',
    'm4b',
    'm4r',
    'm4v',
    'avi',
    'avi',
    'avi',
    'avi',
    'mov',
    'qt',
    'flv',
    'f4v',
    'f4p',
    'f4a',
    'f4b',
    'wmv',
    'wma',
    'wmv',
    'swf',
    'swf',
  ],
  audio: [
    'aac',
    'aif',
    'aiff',
    'aifc',
    'aif',
    'aiff',
    'aifc',
    'wav',
    'wave',
    'wav',
    'wave',
    'wav',
    'wave',
    'wav',
    'wave',
    'flac',
    'ogg',
    'oga',
    'mp3',
    'mp3',
    'pcm',
  ],
  archive: ['zip', 'zipx', 'bdoc', 'edoc', 'rar', 'rev', 'r00', 'r01', 'rar', '7z', 'bz2', 'gz', 'bz2', 'gz', 'epub'],
  special: ['edoc', 'bdoc'],
  misc: ['csv', 'indd', 'ind', 'indt', 'xml', 'xml', 'html', 'htm', 'azw', 'mobi'],
}

// Converts some colors, guide: https://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately
export function HSVtoRGB(h, s, v) {
  let r, g, b, i, f, p, q, t
  if (arguments.length === 1) {
    ;(s = h.s), (v = h.v), (h = h.h)
  }
  i = Math.floor(h * 6)
  f = h * 6 - i
  p = v * (1 - s)
  q = v * (1 - f * s)
  t = v * (1 - (1 - f) * s)
  switch (i % 6) {
    case 0:
      ;(r = v), (g = t), (b = p)
      break
    case 1:
      ;(r = q), (g = v), (b = p)
      break
    case 2:
      ;(r = p), (g = v), (b = t)
      break
    case 3:
      ;(r = p), (g = q), (b = v)
      break
    case 4:
      ;(r = t), (g = p), (b = v)
      break
    case 5:
      ;(r = v), (g = p), (b = q)
      break
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255),
  }
}
export function fileType(extension) {
  let formatedExtension = extension
  if (extension && extension.includes('/')) {
    let splitFormat = extension.split('/')
    formatedExtension = splitFormat[1]
  }
  formatedExtension = formatedExtension.toLowerCase()
  if (fileExtensions.documents.includes(formatedExtension)) {
    return 'document'
  } else if (fileExtensions.presentation.includes(formatedExtension)) {
    return 'presentation'
  } else if (fileExtensions.sheets.includes(formatedExtension)) {
    return 'sheet'
  } else if (fileExtensions.displayImage.includes(formatedExtension)) {
    return 'displayImage'
  } else if (fileExtensions.image.includes(formatedExtension)) {
    return 'image'
  } else if (fileExtensions.video.includes(formatedExtension)) {
    return 'video'
  } else if (fileExtensions.audio.includes(formatedExtension)) {
    return 'audio'
  } else if (fileExtensions.archive.includes(formatedExtension)) {
    return 'archive'
  } else if (fileExtensions.special.includes(formatedExtension)) {
    return 'special'
  } else if (fileExtensions.misc.includes(formatedExtension)) {
    return 'misc'
  } else if (formatedExtension === 'link') {
    return 'link'
  }
  return 'other'
}

export function attachmentIcon(attachment) {
  let iconType = []
  let attachmentFormat = attachment.extension || attachment.type
  switch (fileType(attachmentFormat)) {
    case 'document':
      iconType = 'icon-file-document'
      break
    case 'presentation':
      iconType = 'icon-file-presentation'
      break
    case 'sheet':
      iconType = 'icon-file-spreadsheet'
      break
    case 'displayImage':
      iconType = 'icon-file-image'
      break
    case 'image':
      iconType = 'icon-file-image'
      break
    case 'video':
      iconType = 'icon-file-video'
      break
    case 'audio':
      iconType = 'icon-file-audio'
      break
    case 'archive':
      iconType = 'icon-file-zip'
      break
    case 'link':
      iconType = 'no-icon'
      break
    default:
      iconType = 'icon-file-typ'
      break
  }

  return iconType
}
